import { DealStages_s, ImportFrom_s, VtsImport_s } from 'components/import-export/import-export-styles';
import ListboxInput from 'components/inputs/listbox';
import importService from 'data/import';
import { local } from 'data/lib/local-json';
import _ from 'lodash';
import React, { FC, useState } from 'react';
import { ButtonWithPress_s, Button_s } from 'styles/app-styles';
import { FormError_s } from "styles/form-styles";

const VTSImport: FC = () => {
  const [includePortfolio, setIncludePortfolio] = useState<boolean>(true);
  const [includeDeals, setIncludeDeals] = useState<boolean>(true);
  const [selectedStages, setSelectedStages] = useState<string[]|null>([])

  const stages:any[] = [{
    label: 'Dead Deal',
    value: 'dead_deal'
  },{
    label: 'Idle',
    value: 'idle'
  },{
    label: 'Initial Inquiry',
    value: 'initial_inquiry'
  },{
    label: 'Tenants in the Market',
    value: 'tenants_in_the_market'
  },{
    label: 'Tour',
    value: 'tour'
  },{
    label: 'Preview',
    value: 'preview'
  },{
    label: 'Proposal',
    value: 'proposal'
  },{
    label: 'LOI',
    value: 'loi'
  },{
    label: 'Lease Out',
    value: 'lease_out'
  },{
    label: 'Lease Executed',
    value: 'lease_executed'
  }];

  function toggleImportFrom(e, key){

    if (key === 'includeDeals' && e.target.checked === true){
      setIncludeDeals(e.target.checked);
      setSelectedStages([]);
    } else if (key === 'includeDeals' && e.target.checked === false){
      setIncludeDeals(e.target.checked);
      setSelectedStages(null);
    } else {
      setIncludePortfolio(e.target.checked)
    }
  }

  const handleVTSImport = () => {
    let currentFolderId = _.last(local('folderPath'));
    let vtsImportRoute = `vts/import?DestinationFolderId=${currentFolderId}`;
    if (includeDeals) vtsImportRoute += `&StageFilter=${selectedStages?.toString()}`;
    if (!includePortfolio) vtsImportRoute += `&excludePortfolio=true`;
    if (!includeDeals) vtsImportRoute += `&excludeDeal=true`;
    importService.importVTSFolder(currentFolderId, vtsImportRoute);
  }

  return (
    <VtsImport_s>
      <ImportFrom_s>
        <label>Import From</label>
        <div>
          <input type="checkbox" checked={includePortfolio} onChange={(e)=>toggleImportFrom(e, 'includePortfolio')} />
          <label>Portfolio</label>
        </div>
        <div>
          <input type="checkbox" checked={includeDeals} onChange={(e)=>toggleImportFrom(e, 'includeDeals')} />
          <label>Deals</label>
        </div>
        <ButtonWithPress_s primary disabled={includeDeals && !selectedStages || selectedStages && selectedStages.length === 0 || !includeDeals && !includePortfolio} onClick={handleVTSImport}>Submit</ButtonWithPress_s>
      </ImportFrom_s>
    { includeDeals && 
      <DealStages_s>
        <label>Deal Stages</label>
        { selectedStages && selectedStages.length === 0 && <FormError_s>
          Please select one or more deal stage(s)
        </FormError_s> } 
        <Button_s onClick={selectedStages && selectedStages.length === 0 ? ()=> setSelectedStages(stages.map(val => val.value)) : ()=>setSelectedStages([])}>
          { selectedStages && selectedStages.length > 0 ? 'Deselect All' : 'Select All' }
        </Button_s>
        <ListboxInput 
          field="selectedStages"
          multiple={true} 
          options={stages} 
          value={selectedStages} 
          persist={(field:string, val:string[]) => setSelectedStages(val)}
        />
      </DealStages_s>
    }
  </VtsImport_s>
  )
}

export default VTSImport